module.exports = __webpack_public_path__ + "media/images/star_icon_0-00f2c8889bb20b9e5204cf50e9940b4d.svg";